<template>
    <div class="finance-record-page">
      <!-- 筛选区域 -->
      <div class="search-form-container">
        <el-form :inline="true" :model="searchForm" class="search-form" label-width="80px">
          <!-- 手机号筛选 -->
          <el-form-item label="手机号">
            <el-input
              v-model="searchForm.phone"
              placeholder="请输入手机号"
              clearable
              maxlength="11"
              style="width: 200px;"
              @keyup.enter="handleSearch"
            />
          </el-form-item>
  
          <!-- 分类筛选 -->
          <el-form-item label="分类">
            <el-select
              v-model="searchForm.cate"
              placeholder="请选择分类"
              clearable
              style="width: 150px;"
            >
              <el-option label="入账" value="1" />
              <el-option label="出账" value="2" />
            </el-select>
          </el-form-item>
  
          <!-- 类型筛选 -->
          <el-form-item label="类型">
            <el-select
              v-model="searchForm.type"
              placeholder="请选择类型"
              clearable
              style="width: 150px;"
            >
              <el-option label="可回收物" value="1" />
              <el-option label="奖励" value="2" />
              <el-option label="提现" value="3" />
              <el-option label="提现退回" value="4" />
              <el-option label="余额转环保金" value="5" />
              <el-option label="可回收物未通过" value="6" />
            </el-select>
          </el-form-item>
  
          <!-- 回收单号筛选 -->
          <el-form-item label="回收单号">
            <el-input
              v-model="searchForm.recycleNo"
              placeholder="请输入回收单号"
              clearable
              style="width: 200px;"
              @keyup.enter="handleSearch"
            />
          </el-form-item>
  
          <!-- 操作时间范围筛选 -->
          <el-form-item label="操作时间">
            <el-date-picker
              v-model="searchForm.operateTimeRange"
              type="datetimerange"
              range-separator="至"
              start-placeholder="开始日期"
              end-placeholder="结束日期"
              clearable
              style="width: 300px;"
              value-format="yyyy-MM-dd HH:mm:ss"
            />
          </el-form-item>
  
          <!-- 操作按钮 -->
          <el-form-item>
            <el-button type="primary" @click="handleSearch">查询</el-button>
            <el-button @click="handleReset">重置</el-button>
          </el-form-item>
        </el-form>
      </div>
  
      <!-- 列表展示区域 -->
      <div class="table-container">
        <el-table
          :data="tableData"
          border
          stripe
          v-loading="loading"
          highlight-current-row
          style="width: 100%;"
        >
          <!-- 手机号 -->
          <el-table-column
            prop="phone"
            label="手机号"
            width="150"
            align="center"
          />
  
          <!-- 分类（格式化显示） -->
          <el-table-column
            prop="cate"
            label="分类"
            width="100"
            align="center"
          >
            <template slot-scope="scope">
              <el-tag
                :type="scope.row.cate === 1 ? 'success' : 'danger'"
              >
                {{ scope.row.cate === 1 ? '入账' : '出账' }}
              </el-tag>
            </template>
          </el-table-column>
  
          <!-- 类型（格式化显示） -->
          <el-table-column
            prop="type"
            label="类型"
            width="120"
            align="center"
          >
            <template slot-scope="scope">
              {{ formatType(scope.row.type) }}
            </template>
          </el-table-column>
  
          <!-- 金额（区分正负） -->
          <el-table-column
            prop="amount"
            label="金额(元)"
            width="120"
            align="center"
          >
            <template slot-scope="scope">
              <span :style="{ color: scope.row.cate === 1 ? '#67c23a' : '#f56c6c' }">
                {{ scope.row.cate === 1 ? '+' : '-' }}{{ scope.row.amount.toFixed(2) }}
              </span>
            </template>
          </el-table-column>
  
          <!-- 交易前金额 -->
          <el-table-column
            prop="beforeAmount"
            label="交易前金额(元)"
            width="140"
            align="center"
          >
            <template slot-scope="scope">
              {{ scope.row.beginAmount.toFixed(2) }}
            </template>
          </el-table-column>
  
          <!-- 交易后金额 -->
          <el-table-column
            prop="afterAmount"
            label="交易后金额(元)"
            width="140"
            align="center"
          >
            <template slot-scope="scope">
              {{ scope.row.afterAmount.toFixed(2) }}
            </template>
          </el-table-column>
  
          <!-- 回收单号 -->
          <el-table-column
            prop="orderNo"
            label="回收单号"
            min-width="180"
            align="center"
          >
            <template slot-scope="scope">
              {{ scope.row.orderNo || '-' }}
            </template>
          </el-table-column>
  
          <!-- 操作时间 -->
          <el-table-column
            prop="createTime"
            label="操作时间"
            width="200"
            align="center"
          >
            <template slot-scope="scope">
              {{ formatTime(scope.row.createTime) }}
            </template>
          </el-table-column>
        </el-table>
  
        <!-- 分页组件 -->
        <el-pagination
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page="pagination.pageNum"
          :page-sizes="[10, 20, 50, 100]"
          :page-size="pagination.pageSize"
          layout="total, sizes, prev, pager, next, jumper"
          :total="pagination.total"
          style="margin-top: 20px; text-align: right;"
        >
        </el-pagination>
      </div>
    </div>
  </template>
  
  <script>
  import moment from 'moment';
  import { getUserAmountListRecord } from "@/api/recyclingMachine";
  
  export default {
    name: 'FinanceRecordList',
    data() {
      return {
        // 加载状态
        loading: false,
        // 筛选表单
        searchForm: {
          phone: '', // 手机号
          cate: '', // 分类：1-入账 2-出账
          type: '', // 类型：1-可回收物 2-奖励 3-提现 4-提现退回 5-余额转环保金 6-可回收物未通过
          recycleNo: '', // 回收单号
          operateTimeRange: [] // 操作时间范围
        },
        // 表格数据
        tableData: [],
        // 分页参数
        pagination: {
          pageNum: 1, // 当前页
          pageSize: 10, // 每页条数
          total: 0 // 总条数
        }
      };
    },
    created() {
      // 初始化时获取路由参数中的手机号
      this.initPhoneParam();
      // 初始化加载列表（会根据手机号参数自动筛选）
      this.getList();
    },
    methods: {
      /**
       * 初始化路由传递的手机号参数
       */
      initPhoneParam() {
        // 兼容路由参数的两种传递方式：params 或 query
        const routePhone = this.$route.params.phone || this.$route.query.phone || '';
        console.log('路由传递的手机号参数：', routePhone);
        if (routePhone) {
          // 填充手机号到搜索框
          this.searchForm.phone = routePhone.trim();
        }
      },
  
      /**
       * 格式化类型显示
       * @param {String|Number} type 类型编码
       * @returns {String} 类型名称
       */
      formatType(type) {
        const typeMap = {
          1: '可回收物',
          2: '奖励',
          3: '提现',
          4: '提现退回',
          5: '余额转环保金',
          6: '可回收物未通过'
        };
        return typeMap[type] || '未知类型';
      },
  
      /**
       * 格式化时间显示
       * @param {String} time 时间字符串
       * @returns {String} 格式化后的时间
       */
      formatTime(time) {
        return time ? moment(time).format('YYYY-MM-DD HH:mm:ss') : '-';
      },
  
      /**
       * 获取列表数据
       */
      async getList() {
        this.loading = true;
        try {
          // 构造请求参数
          const params = {
            pageNum: this.pagination.pageNum,
            pageSize: this.pagination.pageSize,
            phone: this.searchForm.phone.trim(), // 自动携带手机号参数（空则查全部）
            cate: this.searchForm.cate,
            type: this.searchForm.type,
            recycleNo: this.searchForm.recycleNo.trim(),
            createTimeStart: this.searchForm.operateTimeRange[0] || '',
            createTimeEnd: this.searchForm.operateTimeRange[1] || ''
          };
  
          const res = await getUserAmountListRecord(params);
  
          if (res.code === 200) {
            this.tableData = res.data.records || [];
            this.pagination.total = res.data.total || 0;
          } else {
            this.$message.error(res.msg || '获取数据失败');
          }
        } catch (error) {
          console.error('获取收支记录失败：', error);
          this.$message.error('网络异常，获取数据失败');
        } finally {
          this.loading = false;
        }
      },
  
      /**
       * 搜索按钮点击事件
       */
      handleSearch() {
        this.pagination.pageNum = 1; // 重置页码
        this.getList();
      },
  
      /**
       * 重置筛选条件
       */
      handleReset() {
        this.searchForm = {
          phone: '',
          cate: '',
          type: '',
          recycleNo: '',
          operateTimeRange: []
        };
        this.pagination.pageNum = 1;
        this.getList();
      },
  
      /**
       * 每页条数变化
       * @param {Number} val 每页条数
       */
      handleSizeChange(val) {
        this.pagination.pageSize = val;
        this.pagination.pageNum = 1;
        this.getList();
      },
  
      /**
       * 当前页变化
       * @param {Number} val 当前页
       */
      handleCurrentChange(val) {
        this.pagination.pageNum = val;
        this.getList();
      }
    }
  };
  </script>
  
  <style scoped lang="less">
  .finance-record-page {
    padding: 20px;
    background: #f5f7fa;
    min-height: calc(100vh - 60px);
  }
  
  /* 筛选表单样式 */
  .search-form-container {
    background: #fff;
    padding: 20px;
    border-radius: 8px;
    box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.05);
    margin-bottom: 20px;
  }
  
  .search-form {
    display: flex;
    flex-wrap: wrap;
    align-items: center;
    gap: 15px 0;
  }
  
  /* 表格容器样式 */
  .table-container {
    background: #fff;
    padding: 20px;
    border-radius: 8px;
    box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.05);
  }
  
  /* 适配小屏幕 */
  @media screen and (max-width: 1200px) {
    .search-form {
      flex-direction: column;
      align-items: flex-start;
    }
  
    .search-form .el-form-item {
      margin-right: 0 !important;
    }
  }
  </style>